export default "__VITE_ASSET__9SRR0pKG__"